module.exports = __webpack_public_path__ + "front/img/35.a067ca91.png";